import {connect} from 'react-redux'

import type {State} from '../../../../../../../reducers/types'
import {getBuild, getBuildType, getProject} from '../../../../../../../selectors'

import DownloadTestsButton from './DownloadTestsButton'
import type {OwnProps, StateProps} from './DownloadTestsButton.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const {number: buildNumber, buildType} = getBuild(state, buildId) || {}
  const {projectId, name: buildTypeName} = getBuildType(state, buildType) || {}
  const {name: projectName} = getProject(state, projectId) || {}
  return {
    buildNumber,
    projectName,
    buildTypeName,
  }
}

export default connect(mapStateToProps, {})(DownloadTestsButton)
